/**
 * Placeholder for dashboard routes the overlay's Settings panel
 * advertises but the app hasn't implemented yet.  Honest "coming
 * soon" beats silently redirecting people back to Home — when we
 * wire these up, swap the route's element for the real component.
 */
export function ComingSoon({ title, blurb }) {
  return (
    <div className="page">
      <div className="page__title">
        <div>
          <h1>{title}</h1>
          <p className="page__subtitle">{blurb}</p>
        </div>
      </div>
      <div className="state">
        <div className="state__title">Coming soon</div>
        <div>
          This page is promised by the admin overlay's Settings panel
          but hasn't landed yet. Everything you can actually do today
          is in the sidebar — Projects, Team, and Audit log.
        </div>
      </div>
    </div>
  );
}
